<template>
  <div class="search-bar">
    <b-form-group
      label-for="navbar-search-input"
      label-cols-sm="auto"
      class="mb-0"
    >
      <b-input-group size="sm">
        <b-form-input
          id="navbar-search-input"
          v-model="searchTerm"
          :placeholder="$t('t-search-placeholder')"
          @keyup.enter="onSearch"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="dark" @click="onSearch">
            <i class="mdi mdi-magnify"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <!-- Das Dropdown für Ergebnisse wird nicht mehr benötigt -->
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "SearchBar",
  setup() {
    const router = useRouter();
    const searchTerm = ref("");

    const onSearch = () => {
      if (searchTerm.value.trim() !== "") {
        // Navigiere zur Suchergebnisseite und übergebe den Suchbegriff als Query-Parameter
        router.push({ name: "SearchResults", query: { q: searchTerm.value } });
      }
    };

    return {
      searchTerm,
      onSearch,
    };
  },
};
</script>

<style>
.search-bar {
  width: 250px;
}
</style>
